import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=456c8c21&"
import script from "./ButtonComponent.vue?vue&type=script&lang=js&"
export * from "./ButtonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports